module.exports = __webpack_public_path__ + "static/media/02-thumbnail.e52270b3.jpg";